import { useState } from "react";
import { toast } from "sonner";
import { Flag } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const REASONS = [
  ["contacts", "Condivide contatti (telefono, email, social)"],
  ["fake", "Profilo o evento falso"],
  ["inappropriate", "Contenuto inappropriato"],
  ["other", "Altro"],
];

export const ReportButton = ({ targetType, targetId, label = "Segnala" }) => {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("contacts");
  const [details, setDetails] = useState("");
  const [loading, setLoading] = useState(false);
  if (!user || user.role === "admin") return null;

  const send = async () => {
    setLoading(true);
    try {
      await api.post("/reports", { target_type: targetType, target_id: targetId, reason, details });
      toast.success("Segnalazione inviata. Grazie, la valuteremo al più presto.");
      setOpen(false);
      setDetails("");
      setReason("contacts");
    } catch (e) { toast.error(formatApiError(e)); } finally { setLoading(false); }
  };

  return (
    <>
      <button onClick={() => setOpen(true)} className="flex items-center gap-1.5 text-[11px] uppercase tracking-[0.15em] text-neutral-500 hover:text-red-400 transition-colors" data-testid={`report-${targetType}-button`}>
        <Flag className="w-3 h-3" /> {label}
      </button>
      <Dialog open={open} onOpenChange={(o) => { setOpen(o); if (!o) { setReason("contacts"); setDetails(""); } }}>
        <DialogContent className="bg-[#121418] border-white/10 rounded-sm" data-testid="report-dialog">
          <DialogHeader>
            <DialogTitle className="font-serif text-3xl font-normal">Segnala {targetType === "hostess" ? "profilo" : "evento"}</DialogTitle>
            <DialogDescription className="text-neutral-400">Il tuo nome non verrà mostrato all'utente segnalato: la segnalazione sarà valutata dall'amministrazione.</DialogDescription>
          </DialogHeader>
          <div className="space-y-2">
            {REASONS.map(([v, l]) => (
              <button key={v} type="button" onClick={() => setReason(v)} data-testid={`report-reason-${v}`}
                className={`w-full text-left px-4 py-3 text-sm border transition-colors ${reason === v ? "border-[#D4AF37] bg-[#D4AF37]/5 text-white" : "border-white/10 text-neutral-400 hover:border-white/30"}`}>{l}</button>
            ))}
          </div>
          <textarea rows={3} maxLength={500} value={details} onChange={(e) => setDetails(e.target.value)} placeholder="Dettagli (opzionale)" className="lux-input resize-none" data-testid="report-details-input" />
          <button onClick={send} disabled={loading} className="btn-gold w-full" data-testid="report-submit-button">{loading ? "Invio…" : "Invia segnalazione"}</button>
        </DialogContent>
      </Dialog>
    </>
  );
};
